exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-background-2fpgk{background-color:#fff;width:100%;height:100%}.style-cssmodule-container-10RgR{--max-width:1800px;container-type:inline-size;padding:var(--global-padding);max-width:var(--max-width);width:100%;margin:0 auto;gap:20px;display:flex;flex-direction:column}.style-cssmodule-pageTitle-mHgTv{color:var(--color-flow);font-size:24px;margin-bottom:0;margin-top:5px;max-width:70vw}.style-cssmodule-card-32m6Y{box-shadow:var(--card-shadow)}.style-cssmodule-container-10RgR header{display:block}.style-cssmodule-title-3HmrI{color:var(--color-night-gray9,#2c3652);font-family:Roboto;font-size:24px;font-style:normal;font-weight:400;line-height:36px}", ""]);

// exports
exports.locals = {
	"background": "style-cssmodule-background-2fpgk",
	"container": "style-cssmodule-container-10RgR",
	"pageTitle": "style-cssmodule-pageTitle-mHgTv",
	"card": "style-cssmodule-card-32m6Y",
	"title": "style-cssmodule-title-3HmrI"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/accounts/style.cssmodule.css
// module id = 2553
// module chunks = 121